import React from "react";
import { Link } from "react-router-dom";
import { BadgeCheck, Eye, FlaskConical, Handshake, LineChart, Timer } from "lucide-react";
import { Stagger, StaggerItem } from "../lib/motion";

const CARDS = [
  {
    icon: BadgeCheck, title: "The report isn't ours",
    body: "Every gemstone above ₹10,000 carries a GIA, GTL Jaipur or IGI report you check on the laboratory's own website. We cannot edit that page.",
    to: "/about/verification",
  },
  {
    icon: Eye, title: "You see it loose first",
    body: "Photographed out of the packet on a grey card with a millimetre scale. Nothing is set until you have looked at it and said yes.",
    to: "/promises",
  },
  {
    icon: FlaskConical, title: "Test us at our expense",
    body: "Take it to any accredited laboratory within 30 days. If anything differs from our report, full refund and we pay your laboratory fee.",
    to: "/promises",
  },
  {
    icon: Handshake, title: "Zero commission advice",
    body: "Your consultant earns nothing from what you buy — no commission, no bonus, no target. It is written into their contract, not just our copy.",
    to: "/about/consultants",
  },
  {
    icon: Timer, title: "72 hours or refunded",
    body: "Dispatch within 72 hours or the order refunds itself automatically. You don't have to ask, and you don't have to prove anything.",
    to: "/legal/shipping",
  },
  {
    icon: LineChart, title: "We publish the numbers",
    body: "Refund rate, refund turnaround, dispatch rate and how often a consultation ends with no product recommendation at all. Read weekly from the database.",
    to: "/about/scoreboard",
  },
];

export function WhyUs() {
  return (
    <Stagger
      className="grid gap-[18px] sm:grid-cols-2 lg:grid-cols-3"
      stagger={0.07}
      data-testid="why-us"
    >
      {CARDS.map(({ icon: Icon, title, body, to }, i) => (
        <StaggerItem key={title}>
          <Link
            to={to}
            data-testid={`why-us-card-${i + 1}`}
            className="card-s elev group relative flex h-full flex-col overflow-hidden p-7 transition-colors duration-300 hover:border-gold"
          >
            <span
              className="absolute left-0 top-0 h-full w-[3px] bg-gold opacity-0 transition-opacity duration-300 group-hover:opacity-100"
              aria-hidden="true"
            />
            <span className="ghost-num absolute right-5 top-4" aria-hidden="true">
              {String(i + 1).padStart(2, "0")}
            </span>

            <Icon className="h-[18px] w-[18px] text-gold" aria-hidden="true" />
            <h3 className="mt-5 text-lg leading-tight transition-colors group-hover:text-gold">{title}</h3>
            <p className="mt-3 text-[15px] leading-[1.7] text-dim">{body}</p>
          </Link>
        </StaggerItem>
      ))}
    </Stagger>
  );
}
